<template>
  <div class="mediact">
    <div v-if="data.type=='prods'" id="prods">
      <div @click="btnClick(item.url)" v-for="item,index in data.data[data.type]" :key="index">
        <h1 v-if="playindex!=index">
          <img :src="item.pic" />
          <h2></h2>
          <img :src="require('@/assets/pic/playbtn.png')" />
        </h1>
        <h4 ssrc="item.url" ></h4>
        <label>{{item.label}}</label>
      </div>
      <h3 v-if="false">
        查看更多视频<img :src="require('@/assets/pic/down.png')" />
      </h3>
    </div>
    <div v-if="data.type=='trailer'" id="trailer">
      <div @click="btnClick(item.url)" :class="index%2!=0?'vlfr':'vrfr'" v-for="item,index in data.data[data.type]" :key="index">
        <div class="vlct">
          <div v-if="playindex!=index">
            <img :src="item.pic" />
            <h2></h2>
            <img :src="require('@/assets/pic/playbtn.png')" />
          </div>
          <h4  ssrc="item.url"></h4>
        </div>
        <div class="vrct">
          <label>{{item.title}}</label>
          <label>{{item.desc}}</label>
          <p>了解更多<img :src="require('@/assets/pic/m5ar.png')" /></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
    data () {
      this.playindex = -1
    }
  },
  data () {
    return {
      mnindex: 0,
      playindex: -1,
    }
  },
  methods: {
    btnClick (url) {
      this.data.callback(url)
    },
    // stopPlay () {
    //   var idpre = this.data.type=='prods'?'vdo':'vdot'
    //   var video = document.getElementById(idpre+this.playindex)
    //   video.pause()
    //   this.playEnding()
    // },
    // playEnding () {
    //   var idpre = this.data.type=='prods'?'vdo':'vdot'
    //   var video = document.getElementById(idpre+this.playindex)
    //   video.removeEventListener('ended',this.playEnding)
    //   this.playindex = -1
    // },
    // vdoPlay (index) {
    //   var idpre = this.data.type=='prods'?'vdo':'vdot'
    //   if (this.playindex>-1) {
    //     this.stopPlay()
    //   }
    //   var _this = this
    //   setTimeout(() => {
    //     var video = document.getElementById(idpre+index)
    //     video.play()
    //     _this.playindex = index
    //     video.addEventListener('ended', _this.playEnding)
    //   }, 100)
    // },
    setMenuClass (index) {
      return this.mnindex==index?'mnnlb mnslb':'mnnlb'
    },
    menuSelect (index) {
      this.mnindex = index
      // var items = this.data.data[this.data.category[index].type]
      // this.ctdatas = items?items:[]
    }
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mediact {
  background: #F7F8F8;
  overflow: hidden;
}

#trailer {
  height: 9.48rem;
  text-align: center;
  padding-top: .17rem;
}
.vlct,.vrct {
  display: inline-block;
  overflow: hidden;
  height: 3.51rem;
  text-align: left;
}
.vlct {
  width: 6.23rem;
  float: left;
  cursor: pointer;
}
.vrct {
  width: 6.16rem;
  float: right;
  background: #EF8200;
}
.vrct label {
  display: block;
  margin-left: .43rem;
}
.vrct label:nth-child(1) {
  margin-top: .53rem;
  font-size: .36rem;
  font-weight: 600;
  color: #FFFFFF;
}
.vrct label:nth-child(2) {
  margin-top: .15rem;
  width: 5.32rem;
  font-size: .14rem;
  font-weight: 400;
  color: #FFFFFF;
  line-height: .28rem;
}
.vrct p {
  margin: .63rem 0 0rem .43rem;
  width: 1.99rem;
  height: .57rem;
  font-size: .2rem;
  font-weight: 600;
  border: 1px solid #FFFFFF;
  line-height: .57rem;
  text-align: center;
  color: white;
  border-radius: .4rem;
  cursor: pointer;
}
.vrct p img {
  width: .17rem;
  height: .12rem;
  margin-left: .08rem;
}
.vrfr,.vlfr {
  margin: .33rem auto;
  width: 12.39rem;
  overflow: hidden;
}
.vlfr .vlct {
  float: right;
}
.vlct h4 {
  width: 6.23rem;
  height: 3.51rem;
  margin: 0;
}
.vlct img:nth-child(1) {
  position: absolute;
  width: 6.23rem;
  height: 3.51rem;
}
.vlct h2 {
  position: absolute;
}
.vlct img:nth-child(3) {
  width: .87rem;
  height: .69rem;
  position: absolute;
  margin-left: 2.69rem;
  margin-top: 1.42rem;
}
.vrfr .vrct {
  float: left;
  background: #0080CB ;
}

#prods {
  padding: .5rem 3.45rem 0 3.74rem;
  height: 8.85rem;
}
#prods div {
  display: inline-block;
  width: 3.9667rem;
  height: 2.9129rem;
  margin:  0 .2rem .2rem 0;
  cursor: pointer;
}
#prods label {
  display: block;
  height: .69rem;
  text-align: center;
  line-height: .69rem;
  font-size: .2rem;
  font-weight: 400;
  color: #4E4E4E;
  background: white;
}
#prods div:hover label{
  font-weight: 400;
  color: #FFFFFF;
  background: #EF8200;
}
#prods h1 {
  width: 3.9667rem;
  height: 2.2229rem;
  margin: 0;
  padding: 0;
  position: absolute;
}
#prods h2 {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: black;
  opacity: .34;
}
#prods h4 {
  width: 3.9667rem;
  height: 2.2229rem;
  display: block;
  margin: 0;
}
#prods img {
  position: absolute;
}
#prods h1 img:nth-child(1) {
  width: 3.9667rem;
  height: 2.2229rem;
}
#prods h1 img:nth-child(3) {
  width: .52rem;
  height: .41rem;
  margin: .91rem 0 0 1.73rem;
}
#prods h3 {
  width: 2.24rem;
  height: .57rem;
  line-height: .57rem;
  background: #FFFFFF;
  border: 1px solid #E9E9E9;
  text-align: center;
  margin-left: 5.0367rem;
  font-size: .2rem;
  font-weight: 400;
  color: #616161;
  border-radius: .6rem;
  cursor: pointer;
}
#prods h3 img {
  width: .13rem;
  height: .18rem;
  line-height: .57rem;
  margin-left: .12rem;
  margin-top: .19rem;
}


</style>
